var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('audio',{attrs:{"id":"audios","hidden":"","src":require("./static/img/voice/news.mp3")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }